import MetaTags from '../components/common/MetaTags'

export default function PrivacyPage() {
  return (
    <>
      <MetaTags
        title="Privacy Policy | profile.work"
        description="Learn how profile.work collects, uses, and protects your personal information."
      />
      <div className="py-16 sm:py-24">
        <div className="mx-auto max-w-3xl px-6 lg:px-8">
          <div className="mx-auto max-w-2xl">
            <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
              Privacy Policy
            </h1>
            <p className="mt-6 text-sm text-gray-500">Last updated: January 2025</p>

            <div className="mt-12 space-y-10 text-gray-600">
              <section>
                <h2 className="text-xl font-semibold text-gray-900">1. Information We Collect</h2>
                <p className="mt-4 leading-7">
                  We collect information you provide directly to us when you create an account,
                  build your profile, or contact us. This includes:
                </p>
                <ul className="mt-4 list-disc pl-6 space-y-2">
                  <li>Account information (name, email address, password)</li>
                  <li>Profile information (work history, education, skills, social links)</li>
                  <li>Resume files you upload for parsing</li>
                  <li>Communications you send to us</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900">
                  2. How We Use Your Information
                </h2>
                <p className="mt-4 leading-7">We use the information we collect to:</p>
                <ul className="mt-4 list-disc pl-6 space-y-2">
                  <li>Provide, maintain, and improve our services</li>
                  <li>Create and display your public profile</li>
                  <li>Send you technical notices and support messages</li>
                  <li>Respond to your comments and questions</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900">3. Information Sharing</h2>
                <p className="mt-4 leading-7">
                  Your profile information is publicly visible at your chosen subdomain. We do not
                  sell your personal information to third parties. We may share information with
                  service providers who assist in operating our platform.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900">4. Data Security</h2>
                <p className="mt-4 leading-7">
                  We implement appropriate security measures to protect your personal information.
                  However, no method of transmission over the Internet is 100% secure, and we cannot
                  guarantee absolute security.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900">5. Your Rights</h2>
                <p className="mt-4 leading-7">
                  You can access, update, or delete your profile information at any time through
                  your account settings. You may also request deletion of your account by contacting
                  us.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900">6. Cookies</h2>
                <p className="mt-4 leading-7">
                  We use cookies and similar technologies to maintain your session and remember your
                  preferences. You can control cookies through your browser settings.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900">7. Changes to This Policy</h2>
                <p className="mt-4 leading-7">
                  We may update this privacy policy from time to time. We will notify you of any
                  changes by posting the new policy on this page.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900">8. Contact Us</h2>
                <p className="mt-4 leading-7">
                  If you have questions about this privacy policy, please contact us at{' '}
                  <a
                    href="mailto:privacy@profile.work"
                    className="text-indigo-600 hover:text-indigo-500"
                  >
                    privacy@profile.work
                  </a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
